import {getApi} from '../../modules/common/utils/api'

const api = getApi('default')

export function getUsers(search = '') {
  const audit = window.location.pathname.includes('/audits') ? 'true' : 'false'
  return api.get(`/v3/users?audit=${audit}&limit=50&search=${search}`)
}

export function getUserDetails() {
  return api.get(`v3/users/me`)
}

export function updateUser(params) {
  return api.put(`v3/users/${params.id}`, params)
}

export function getUserPermissions() {
  return api.get(`v3/users/user_permissions`)
}

export function getUserTemplateRulesAndUser(query = '') {
  return api.get(`/v3/users/templates?limit=50&query=${query}`)
}

export function getTrialGuidanceValue(userId) {
  return api.get(`v3/users/${userId}/trial_guidance_tip`)
}
